import React from "react";

import {
    ArrowBackIcon,
    Button,
    ConfirmDialog,
    NotificationSnackbar,
    Skeleton,
    Stack,
} from "shared/ui";

import { OrderItemsList } from "features/OrderDetails/components/OrderItemsList";
import { OrderStatusTimeline } from "features/OrderDetails/components/OrderStatusTimeline";
import { OrderSummary } from "features/OrderDetails/components/OrderSummary";
import { OrderDetailsContext } from "features/OrderDetails/context";
import { useOrderDetailsState } from "features/OrderDetails/hooks/useOrderDetailsState";

import { BackRow, Container, Message } from "./styles";

const OrderDetailsScreen = () => {
    const state = useOrderDetailsState();

    if (state.loading) {
        return (
            <Container>
                <Stack>
                    <Skeleton height="44px" width="200px" />
                    <Skeleton height="220px" />
                    <Skeleton height="220px" />
                </Stack>
            </Container>
        );
    }

    if (state.error || state.order === null) {
        return <Message>Не удалось загрузить заказ</Message>;
    }

    const order = state.order;

    return (
        <OrderDetailsContext.Provider value={state}>
            <Container>
                <BackRow>
                    <Button variant="text" color="neutral" onClick={state.goBack}>
                        <ArrowBackIcon />
                        К заказам
                    </Button>
                </BackRow>

                <Stack>
                    <OrderSummary order={order} />
                    <OrderItemsList order={order} />
                    <OrderStatusTimeline order={order} />
                </Stack>

                <ConfirmDialog
                    open={state.isRefundDialogOpen}
                    title="Возврат платежа"
                    description={`Деньги за заказ №${order.id} вернутся гостю на карту, а заказ перейдёт в статус «Отменён с возвратом денег». Отменить возврат нельзя.`}
                    confirmLabel="Вернуть деньги"
                    saving={state.refunding}
                    onClose={state.closeRefundDialog}
                    onConfirm={state.confirmRefund}
                />

                <NotificationSnackbar {...state.notify.snackbarProps} />
            </Container>
        </OrderDetailsContext.Provider>
    );
};

export const OrderDetails = OrderDetailsScreen;
